const validDragEvents = [];
export default validDragEvents;
